export const CONFIG = {
  CACLINICS_API_URL: process.env.GATSBY_CACLINICS_API_URL,
}
